"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StepsEnum;
(function (StepsEnum) {
    StepsEnum["PURL_STEPS"] = "purl";
    StepsEnum["SECURITY_STEPS"] = "security";
    StepsEnum["DIRECT_STEPS"] = "direct";
    StepsEnum["DIRECT_STEPS_V3"] = "directV3";
    StepsEnum["PURL_STEPS_V3"] = "purlV3";
    StepsEnum["REFUS_V3"] = "refusV3";
    StepsEnum["SECURITY_STEPS_V3"] = "securityV3";
    StepsEnum["PRESENTATION"] = "presentation";
    StepsEnum["NOT_FOUND"] = "not-found";
})(StepsEnum || (StepsEnum = {}));
exports.default = StepsEnum;
